import React from 'react'

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger'
  size?: 'sm' | 'md' | 'lg'
}

const base = 'inline-flex items-center justify-center font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2'

const variantMap: Record<string, string> = {
  primary: 'bg-primary text-white hover:bg-primary-600 focus:ring-primary-500',
  secondary: 'bg-secondary text-white hover:bg-secondary-600 focus:ring-secondary-500',
  ghost: 'bg-transparent text-primary hover:bg-primary/10 focus:ring-primary-300',
  danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500',
}

const sizeMap: Record<string, string> = {
  sm: 'px-2 py-1 text-sm',
  md: 'px-4 py-2 text-base',
  lg: 'px-6 py-3 text-lg',
}

export default function Button({ variant = 'primary', size = 'md', className = '', ...props }: ButtonProps) {
  const v = variantMap[variant] ?? variantMap.primary
  const s = sizeMap[size] ?? sizeMap.md
  return <button className={`${base} ${v} ${s} ${className}`.trim()} {...props} />
}
